var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareViewTele(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.642578,
    width: 43,
    height: 43,
    rx: 12.2857,
    fill: "url(#paint0_linear_1011_19642)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5469 10.8335C34.4285 10.4895 35.3399 11.2609 35.1463 12.1871L31.1926 31.0858C31.0079 31.9719 29.967 32.3709 29.2373 31.8349L23.2688 27.4538L20.2266 30.5602C19.6919 31.1053 18.7702 30.8834 18.5408 30.1566L16.3458 23.1889L10.4622 21.451C9.68933 21.2232 9.64467 20.1481 10.3937 19.8547L33.5469 10.8335ZM30.6446 15.0269C30.9022 14.799 30.6028 14.397 30.311 14.5787L17.6115 22.4547C17.3881 22.5932 17.2854 22.8657 17.3643 23.1174L19.0962 30.7224C19.1305 30.8386 19.2972 30.8222 19.3121 30.7016L19.6993 24.9059C19.7141 24.7629 19.7826 24.6319 19.8899 24.5366L30.6446 15.0269Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3109 14.579C30.6028 14.3974 30.9021 14.7994 30.6445 15.0272L19.8899 24.537C19.7827 24.6322 19.7142 24.7633 19.6993 24.9062L19.3121 30.702C19.2972 30.8225 19.1304 30.839 19.0962 30.7228L17.3643 23.1177C17.2853 22.8661 17.3881 22.5935 17.6115 22.4551L30.3109 14.579Z",
    fill: "#9EC2E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1588 30.8013C18.8788 30.7015 18.642 30.4781 18.5408 30.1565L16.3458 23.1887L10.4622 21.4509C9.68933 21.223 9.64467 20.1479 10.3937 19.8545L33.5468 10.8334C34.1157 10.6115 34.698 10.8542 34.9854 11.304C34.9317 11.2221 34.8677 11.1462 34.7963 11.0792L19.0887 23.9021V24.4635L19.0023 24.401L19.0887 27.9363V30.7716C19.1111 30.782 19.1349 30.7909 19.1587 30.7984V30.8013H19.1588Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2688 27.454L20.2265 30.5604C20.2012 30.5857 20.1744 30.611 20.1476 30.6334C20.1208 30.6557 20.0939 30.6751 20.0657 30.6944C20.0642 30.6959 20.0642 30.6959 20.0642 30.6959C20.0076 30.7331 19.9496 30.7644 19.8885 30.7897C19.8572 30.8016 19.8274 30.8136 19.7962 30.821C19.6666 30.8597 19.5341 30.8701 19.403 30.8567C19.3688 30.8538 19.3345 30.8478 19.3018 30.8419C19.2973 30.8419 19.2929 30.8404 19.2884 30.8389C19.2557 30.83 19.2228 30.8211 19.1901 30.8106C19.1797 30.8077 19.1693 30.8047 19.1588 30.7987L19.0889 27.9366V24.4639L23.2688 27.454Z",
    fill: "#D1D1D1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1487 30.6328C20.1215 30.6556 20.0941 30.6767 20.0654 30.6964V30.6949C20.0942 30.6752 20.1215 30.6556 20.1487 30.6328Z",
    fill: "#DADDE0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0663 30.6943V30.6971C20.0663 30.6971 20.0663 30.6943 20.0635 30.6971C20.0635 30.6971 20.0635 30.6971 20.0663 30.6943Z",
    fill: "#DADDE0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8877 30.7895C19.949 30.7641 20.0072 30.7327 20.064 30.6953C20.0072 30.7326 19.9474 30.764 19.8877 30.7895Z",
    fill: "#DADDE0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4023 30.8564C19.5334 30.8699 19.6659 30.8594 19.7955 30.8203C19.7017 30.8504 19.6048 30.8639 19.5081 30.8639C19.4783 30.8639 19.4485 30.8624 19.4202 30.8594C19.4143 30.8595 19.4083 30.8595 19.4023 30.8564Z",
    fill: "#DADDE0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.404 30.8568C19.41 30.8598 19.416 30.8598 19.422 30.8598C19.3905 30.8583 19.362 30.8537 19.332 30.8477C19.356 30.8523 19.38 30.8553 19.404 30.8568Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4037 30.8567C19.3797 30.8552 19.3557 30.8521 19.3318 30.8476C19.3212 30.8461 19.3108 30.8446 19.3018 30.8416C19.3347 30.8476 19.3692 30.8537 19.4037 30.8567Z",
    fill: "#DADDE0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1895 30.8103C19.2224 30.8209 19.2555 30.83 19.2885 30.8391C19.275 30.8361 19.2615 30.833 19.248 30.8301C19.242 30.8286 19.236 30.8271 19.2315 30.824C19.2179 30.8209 19.2029 30.8164 19.1895 30.8103Z",
    fill: "#DADDE0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.248 30.8291C19.262 30.8322 19.2759 30.8353 19.2898 30.8384C19.2759 30.8368 19.262 30.8338 19.248 30.8291Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.191 30.8104C19.2048 30.8165 19.2201 30.8211 19.2339 30.8241C19.2109 30.8195 19.188 30.8119 19.165 30.8027C19.1742 30.8058 19.1818 30.8089 19.191 30.8104Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1924 30.8118C19.1827 30.8102 19.1745 30.8069 19.1647 30.8037C19.1631 30.8053 19.1598 30.8036 19.1582 30.802V30.7988C19.1695 30.8053 19.181 30.8085 19.1924 30.8118Z",
    fill: "#DADDE0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0889 27.9365L19.1595 30.7986C19.1354 30.7912 19.1114 30.7822 19.0889 30.7718V27.9365Z",
    fill: "#D1D1D1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0891 24.4639V27.9366L19.002 24.4014L19.0891 24.4639Z",
    fill: "#DADDE0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6445 15.0272L19.8899 24.5369C19.7827 24.6322 19.7142 24.7632 19.6993 24.9062L19.3128 30.7024C19.2979 30.823 19.1311 30.8394 19.0954 30.7232L17.3643 23.1177C17.2853 22.8661 17.3881 22.5936 17.6115 22.4551L30.311 14.579C30.6028 14.3973 30.9022 14.7994 30.6445 15.0272Z",
    fill: "#ADBCC9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1011_19642",
    x1: 22.1426,
    y1: 0,
    x2: 22.1426,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AB6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#256FCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareViewTele);
export default __webpack_public_path__ + "static/media/share-view-tele.b9858b01bec5ecb006090aceebffcfcc.svg";
export { ForwardRef as ReactComponent };